/**
 * Created by Christof Sander on 22.12.2016.
 */

var utils = require('frontend-controller/lib/utils');
var store = require('frontend-controller/lib/store');

module.exports = {
	config: {
		registerSecret: 'imageList',
		registerType: 'component',
		forceDomUpdate: 10
	},

	model: {
		mediaList: {},
		selectedMedia: {},
		selectedMediaIndex: 0,
		managementConfig: {},
		lazyloadStepSize: 63, // 9 images * 7 rows
		lazyloadingInEffect: false,
		nrOfElements: {
			nrOfElements: 0,
			nrOfMatchingElements: 0,
			nrOfNonMatchingElements: 0
		}
	},

	events: {
		selectImage: {
			type: 'click',
			action: function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target;
				var mediaID = ($target = $(event.target).closest('.base_form_media_image_image')).data('mediaId');
				var mediaKey;
				if(mediaID){
					utils.performButtonAction(event, undefined, { mediaID: mediaID }).then(function(context){
						var self = event.data.component;

						if(!context.actionPerformed){
							// deselect image
							if($target.hasClass('selected')){
								$target.removeClass('selected');
								event.data.component.model.selectedMedia[mediaID] = -1;
							}
							else {
								// prepare
								var managementConfig    = self.model.managementConfig;
								if(managementConfig.multiSelect !== false && managementConfig.maxNrOfElements <= 1){
									managementConfig.multiSelect = false;
								}

								// deselect all => multi selection not allowed
								if(managementConfig.multiSelect === false){
									if(utils.collectionSize(self.model.selectedMedia) > 0){
										self.$.find('[data-media-id="' + Object.keys(self.model.selectedMedia).join('"],[data-media-id="') + '"]').removeClass('selected');
										self.model.selectedMedia = {};
										self.model.selectedMediaIndex = 0;
									}
								}
								// deselect earliest selected images until maxNrOfElements-limit is not violated any longer if necessary
								else if(managementConfig.maxNrOfElements > 1 && self.model.selectedMediaIndex >= managementConfig.maxNrOfElements){
									var minMediaIndex = (self.model.selectedMediaIndex - managementConfig.maxNrOfElements + 1);
									for(var selectedMediaID in self.model.selectedMedia){
										if(self.model.selectedMedia[selectedMediaID] < minMediaIndex){
											delete self.model.selectedMedia[selectedMediaID];
											self.$.find('[data-media-id="' + selectedMediaID + '"]').removeClass('selected');
										}
									}
								}

								// check if image dimensions are sufficient
								mediaKey = 'mediaID_' + mediaID;
								var imageData = self.model.mediaList[mediaKey];
								if(
									(
										imageData.width > 0
										&&
										imageData.width < (self.model.maxImageDimensions || {}).width || 0
									)
									||
									(
										imageData.height > 0
										&&
										imageData.height < (self.model.maxImageDimensions || {}).height || 0
									)
								){
									self.performDecision(
										'confirm',
										{
											component:  self,
											mediaID:    mediaID,
											title:      __('error:imageManagement.tooSmallImageSelected.title'),
											message:    __('error:imageManagement.tooSmallImageSelected.message', { max: self.model.maxImageDimensions, image: { width: imageData.width, height: imageData.height }})
										}
									).then(function(context){
										if(context.decision.type === 'yes'){
											// select image
											$target.addClass('selected');
											context.scope.component.model.selectedMedia[context.scope.mediaID] = context.scope.component.model.selectedMediaIndex++;
										}
									});
								}
								else {
									// select image
									$target.addClass('selected');
									event.data.component.model.selectedMedia[mediaID] = event.data.component.model.selectedMediaIndex++;
								}
							}
						}

						self.updateNrOfElements();
					});
				}
			}
		},

		showImageDetailsSummary: {
			type: 'mouseenter',
			selector: '.base_form_media_image_image',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('.base_form_media_image_image');
				if($target.length > 0){
					var mediaID = $target.data('mediaId');
					if(mediaID){
						var media = self.getMediaByID(mediaID);
						if(Object.keys(media).length > 0){
							self.triggerClosest('showMediaDetails', { media: media })
						}
					}
				}
			}
		},

		lazyloadClick: {
			type: 'click',
			selector: 'button[data-field-type="lazyload"]',
			action: function(event){
				event.data.component.lazyloadNext();
			}
		},

		lazyloadScroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				event.data.component.onScrollLazyload($(event.target).closest('section.content'), event.data.component.$);
			}
		}
	},

	methods: {
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			if(additionalData.mediaID){
				var $target = self.$.find('[data-media-id="' + additionalData.mediaID + '"]').addClass('deletionInProgress');
				var messageBaseName = 'hint.delete.really.media';
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      __(messageBaseName + '.title'),
						message:    __(messageBaseName + '.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(
							self.prepareAction('deleteMedia', additionalData.mediaID)
						).then(function(context){
							$target.addClass('deleted');
							delete self.model.mediaList['mediaID_' + additionalData.mediaID];
							self.model.selectedMedia[additionalData.mediaID] = -1;
							if(self.model.$newImageList.find('[data-media-id]:not(.deleted)').length === 0){
								self.model.$newImageContainer.removeClass('active');
							}
							self.updateNrOfElements();
						}).fail(function(error){
							$target.removeClass('deletionInProgress');
						});
					} else {
						$target.removeClass('deletionInProgress');
					}
				});
			}
		},

		dataDealer: function(){
			this.model.imageConfig          = this.getResourceRegisterContent('imageConfig') || {};
			this.model.managementConfig     = this.model.imageConfig.managementConfig || {};
			this.model.maxImageDimensions   = utils.media.image.detectMaxDimensions(this.model.imageConfig);
			this.model.listOfMediaIDs 		= this.getResourceRegisterContent('listOfMediaIDs') || [];
		},

		prepare: function(storage){
			var user = (storage|| {}).user
			if(user) 	this.model.extendedButtonActionsGranted = user.hasAccessTo('usage:media:extendedButtonActions', this.scope)
			else 		this.model.extendedButtonActionsGranted = false;
		},

		sanitizeResources: function(storage){
			if(!this.config.isReady){
				this.model.mediaList = {};
			}

			var self 		= this;
			var mediaList 	= this.model.mediaList;
			var mediaKey;
			var domImagePresent;

			if(self.resourceData && self.resourceData.data && (!self.resourceData.initialized || self.model.lazyloadingInEffect)){
				self.resourceData.initialized = true;

				utils.forEach(self.resourceData.data, function(image){
					utils.media.image.prepare(image, storage, false);

					// this key is necessary to prevent order issues
					mediaKey = 'mediaID_' + image.mediaID;

					domImagePresent = self.model.lazyloadingInEffect && mediaList[mediaKey] && mediaList[mediaKey] !== -1;
					delete mediaList[mediaKey];
					mediaList[mediaKey] = image;

					// add lazyloaded images if necessary
					if(self.config.isReady && !domImagePresent){
						self.addImage(image, false);
					}
				});
			}

			self.updateNrOfElements();
		},

		getResourceFilters: function(){
			if(!this.model.resourceFilters) this.model.resourceFilters = {}
			if(!this.model.listOfMediaIDs) this.model.listOfMediaIDs = this.getResourceRegisterContent('listOfMediaIDs') || []
			var filters = this.model.resourceFilters;
			filters.listOfMediaIDs = this.model.listOfMediaIDs;
			if(!this.config.isReady) 	filters.offset = 0;
			if(!filters.offset) 		filters.offset = 0;
			if(!filters.limit) 			filters.limit = filters.offset + (this.model.lazyloadStepSize || 0);

			// FILTER EXAMPLES:
			// filters.listOfCategoryDataIDs = [2];
			// filters.order = 'sizeInBytes';
			// filters.order = [{ field: 'originalName', direction: 'DESC' }];

			return filters;
		},

		setFilter: function(field, value){
			if(!this.model.resourceFilters) this.model.resourceFilters = {}
			if(field) this.model.resourceFilters[field] = value;
			this.model.resourceFilters.offset = 0;
			this.model.resourceFilters.limit = this.model.lazyloadStepSize;
			this.model.mediaList = {};
			this.model.selectedMedia = {};
			this.model.selectedMediaIndex = 0;
			this.refresh();
		},

		updateFilters: function(filters){
			utils.refReplace(this.model.resourceFilters, filters);
			this.setFilter();
		},

		onScrollLazyload: function($scrollContainer, $fullHeightContainer, deltaTime){
			var delta;
			if(deltaTime === undefined) 	deltaTime = 100;
			if(this.model.onScrollTimeout) 	clearTimeout(this.model.onScrollTimeout);

			if(deltaTime > 0){
				this.model.onScrollTimeout = setTimeout(function(self, $scrollContainer, $fullHeightContainer){
					self.onScrollLazyload($scrollContainer, $fullHeightContainer, 0);
				}, deltaTime, this, $scrollContainer, $fullHeightContainer);
			} else {
				if(
					$scrollContainer.length > 0 &&
					$fullHeightContainer.length > 0 &&
					(delta = ($fullHeightContainer.height() - $scrollContainer.height() - $scrollContainer.scrollTop())) <= 50
				){
					this.lazyloadNext();
				}
			}
		},

		lazyloadNext: function(){
			var self = this;
			// prevent lazyloading requests if the last lazyload contained no data
			if(!self.model.lazyloadingInEffect && (self.resourceData.data || []).length > 0){
				self.model.lazyloadingInEffect = true;
				self.model.resourceFilters.offset += self.model.lazyloadStepSize;
				self.performAction('refreshResources')
					.then(function(){ self.model.lazyloadingInEffect = false; })
					.fail(function(){ self.model.lazyloadingInEffect = false; })
				;
			}
		},

		selectAllMedia: function(){
			this.model.selectedMedia = {};
			this.model.selectedMediaIndex = 0;
			for(var m in this.model.mediaList){
				this.model.selectedMedia[this.model.mediaList[m].mediaID] = this.model.selectedMediaIndex++;
			}
			this.$.find('.base_form_media_image_image').addClass('selected');
			this.updateNrOfElements();
		},

		deselectAllMedia: function(){
			this.model.selectedMedia = {};
			this.model.selectedMediaIndex = 0;
			this.$.find('.base_form_media_image_image').removeClass('selected');
			this.updateNrOfElements();
		},

		getSelectedMedia: function(){
			var self = this;
			var selectedMedia = {};
			var mediaKey;

			utils.forEach(self.model.selectedMedia, function(sortIndex, mediaID){
				mediaKey = 'mediaID_' + mediaID;
				if(sortIndex >= 0 && self.model.mediaList[mediaKey]){
					selectedMedia[sortIndex] = self.model.mediaList[mediaKey];
				}
			});

			return selectedMedia;
		},

		getMediaByID: function(mediaID){
			if(mediaID && this.model.mediaList['mediaID_' + mediaID]){
				return this.model.mediaList['mediaID_' + mediaID];
			}
			return {};
		},

		updateMediaTagsByMediaID: function(mediaData){
			var mediaID, mediaKey, storage = store.get(this.requestID, this.sessionID, this.serviceDomain);
			for(var m in mediaData || []){
				utils.media.image.prepare(mediaData[m], storage, false);
				mediaID = mediaData[m].mediaID;
				mediaKey = 'mediaID_' + mediaID;
				if(this.model.mediaList[mediaKey]){
					this.model.mediaList[mediaKey].tags 			= mediaData[m].tags;
					this.model.mediaList[mediaKey].tagsResources 	= mediaData[m].tagsResources;
				}
			}
		},

		addNewImage: function(image, prepend){
			image = image || {};
			var mediaList 	= this.model.mediaList;
			var _primaryKey = image.primaryKey || 'mediaID';
			var primaryKey 	= image[_primaryKey];
			var mediaKey;

			if(primaryKey){
				// this key is necessary to prevent order issues
				mediaKey = 'mediaID_' + primaryKey;

				delete mediaList[mediaKey];
				mediaList[mediaKey] = image;

				this.addImage(image, prepend, true);
				this.updateNrOfElements();
			} else {
				throw new Error('IMAGE-LIST MISSES THE PRIMARY KEY OF THE NEW IMAGE')
			}
		},

		addImage: function(image, prepend, newImage){
			// add image to dom if necessary
			if(this.config.isReady){
				var newImageTag = this.include('../../../base/form/media/image/image', { resourceData: image, config: { context: 'management', controls: { edit: false, renew: false, delete: true, pause: false } }, model: { extendedButtonActionsGranted: this.model.extendedButtonActionsGranted } });
				if(newImage){
					this.model.$newImageContainer.addClass('active');
					if(prepend) this.model.$newImageList.prepend(newImageTag);
					else        this.model.$newImageList.append(newImageTag);
				} else {
					if(prepend) this.model.$imageList.prepend(newImageTag);
					else        this.model.$imageList.append(newImageTag);
				}
			}
		},

		handleError: function(context){
			if(context.action.originalActionKey === 'deleteMedia' && context.error.errorCode === 'USER_PROVIDER_ROUTE_PRIVILEGE_ERROR' && context.error.statusCode === 403){
				return this.performAction(this.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:notAllowed.media.delete'
					}
				}));
			}
			return utils.promise.reject({});
		},

		updateNrOfElements: function(){
			var nrOfElements = ((this.resourceData.nrOfElements || {}).data || {}).attributes || {};

			nrOfElements.nrOfShownElements = 0;
			nrOfElements.sizeOfShownElements = 0;
			nrOfElements.nrOfSelectedElements = 0;
			nrOfElements.sizeOfSelectedElements = 0;

			var mediaID, mediaKey;
			for(mediaID in this.model.selectedMedia){
				if(this.model.selectedMedia[mediaID] !== -1){
					nrOfElements.sizeOfSelectedElements += (this.model.mediaList['mediaID_' + mediaID] || {}).sizeInBytes || 0;
					nrOfElements.nrOfSelectedElements++;
				}
			}
			for(mediaKey in this.model.mediaList){
				nrOfElements.nrOfShownElements++;
				nrOfElements.sizeOfShownElements += (this.model.mediaList[mediaKey] || {}).sizeInBytes || 0;
			}
			this.triggerClosest('updateNrOfElements', { nrOfElements: nrOfElements })
		}
	},

	hooks: {
		initFileList: function($element, options){
			var self = this;
			utils.forEach(self.model.mediaList, function(image){
				self.addImage(image, false);
			});
		},

		attach: function($element, options){
			this.model.$imageList 			= $element.find('.imageList');
			this.model.$newImageContainer 	= $element.find('.newImages');
			this.model.$newImageList 		= $element.find('.newImageList');

			if(!utils.isEmpty(this.model.mediaList)){
				// NOTE: init files after the init process has been completed to prevent long gui-idle-times
				this.triggerWhenReady('initFileList', {});
			}

			if(options.refresh){
				$element.closest('section.content').scrollTop(0);
			}
		}
	}
};